import React from 'react';
import Link from '../../components/Links/link';
import { useTranslation } from 'react-i18next';

export default function Footer() {
    const { t } = useTranslation();

    return (
        <div className='w-full relative'>
            <div className='bg-footer'>
                <div className='text-center text-white opacity-60 py-2'>
                    <span>
                        © {new Date().getFullYear()} - L'Artbanne&nbsp;|&nbsp;
                        &nbsp;|&nbsp;
                        <Link link="https://storage.googleapis.com/fiska-public/ARTBANNE/Legal_Notices.pdf" externalLink={true} text={t('footer.legalNotices')} textColor='white' />
                        &nbsp;|&nbsp;
                        <Link link="https://lartbanne.com/assets/CGV.pdf" text={t('footer.generalConditions')} textColor='white' />
                        {/*&nbsp;|&nbsp; <Link link="/domain" text={t('footer.personalData')} textColor='white' />&nbsp;|&nbsp;
                        <Link link="/domain" text={t('footer.cookieManagement')} textColor='white' /> */}
                    </span>
                </div>
            </div>
        </div>
    );
}